// Shared between the React app and the Pages Functions. Keep this file
// free of runtime dependencies — only types and pure constants live here.
export const READMECATEGORIES = [
    "skill",
    "playbook",
    "research",
    "prompt",
    "other",
];
export const CATEGORY_EMOJI = {
    skill: "🎯",
    playbook: "📋",
    research: "🔬",
    prompt: "💬",
    other: "📄",
};
// Placeholder syntax for template inputs. Chosen to be uncommon in normal
// markdown so it round-trips through GFM without escaping.
// Accepts any character that is not `>` so Hebrew, brackets, and long
// descriptions all work (e.g. <<[למשל: נושא השיר]>>).
export const PLACEHOLDER_REGEX = /<<([^>]{1,512})>>/g;
// ── Shared Plans ──────────────────────────────────────────────────────────────
/**
 * Legacy "everyone" marker. Historically an item assigned to everyone stored a
 * single assignment whose displayName equalled this string. New code uses
 * `PlanItem.assignmentType === "all"` instead; the sentinel is kept only so old
 * persisted plans can be normalized on read. Do NOT write new sentinel rows.
 */
export const EVERYONE_SENTINEL = "כולם";
// ── List export / import ────────────────────────────────────────────────────
/**
 * Versioned, list-only export of a plan's structure. Deliberately excludes all
 * people/assignment/completion state (checked, assignments, notes, participants,
 * active users, revisions, plan id/token/version) so a list can be shared and
 * merged into another plan without leaking who-does-what.
 */
export const LIST_EXPORT_SCHEMA_V1 = "nodeone-list-export-v1";
/**
 * Versioned plan package (v2). A superset envelope around the same list-only
 * structure as v1, but with an explicit `kind` so a file can be exported and
 * recognised as a plain list or as a reusable template. Like v1 it deliberately
 * excludes all people/assignment/completion state. A future "backup" kind may be
 * added; it is intentionally NOT part of this union yet.
 */
export const PLAN_PACKAGE_SCHEMA_V2 = "nodeone-plan-package-v2";
